import {sweetAPI} from 'app/store/sweet-api';
import {TASKS_GUEST_INSTANCE_API_URL} from 'app/urls';

import {reformatGuestTaskURLs} from './utils/reformat-urls';

import type {TaskConcreteInstanceSerializedType} from 'sweet-types';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: ['GuestTask']})
  .injectEndpoints({
    endpoints: (build) => ({
      getGuestTaskInstance: build.query<
        TaskConcreteInstanceSerializedType,
        string
      >({
        query: (id) => `${TASKS_GUEST_INSTANCE_API_URL}${id}/`,
        transformResponse: reformatGuestTaskURLs,
      }),
      updateGuestTaskInstance: build.mutation<
        TaskConcreteInstanceSerializedType,
        {id: string}
      >({
        query: ({id, ...body}) => ({
          url: `${TASKS_GUEST_INSTANCE_API_URL}${id}/`,
          method: 'PATCH',
          body,
        }),
        transformResponse: reformatGuestTaskURLs,
        // update task cache
        onQueryStarted: async ({id}, {queryFulfilled, ...api}) => {
          queryFulfilled.then(({data}) =>
            api.dispatch(
              extendedAPI.util.updateQueryData(
                'getGuestTaskInstance',
                id.toString(),
                () => data
              )
            )
          );
        },
      }),
    }),
  });

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {
  useQuery: useGuestTaskInstance,
  //useLazyQuery: useLazyGuestTaskInstance,
  //useQueryState: useGuestTaskInstanceState,
} = extendedAPI.endpoints.getGuestTaskInstance;

// hook to update task
export const {useMutation: useUpdateGuestTaskInstance} =
  extendedAPI.endpoints.updateGuestTaskInstance;
